import { Loader } from '@shared-ui/components/ui/loader'
import styles from '@web/router/fallback/index.module.css'

export function RouteFallback() {
  return (
    <div className={styles.root}>
      <Loader size={45} />
    </div>
  )
}
